export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'MindSpace',
    headline: 'One stop solution for mental health illness',
    description: 'WE are here to mitigate your mental health, join us to help you',
    buttonLabel: 'Get started',
    imgStart: false,
    alt: 'car',
    img: './assets/img1.svg',
    dark: true,
    darkText: false,
    primary: true
}
export const homeObjTwo = {
    id: 'discover',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Access to Notifications',
    headline: 'Motivation, Routine',
    description: 'Get access to out exclusive app that allows you to send unlimited transactions without getting charged fees.',
    buttonLabel: 'Learn more',
    imgStart: true,
    alt: 'car',
    img: './assets/img1.svg',
    dark: false,
    darkText: true,
    primary: false
}
export const homeObjThree = {
    id: 'signup',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Let us know more about You',
    headline: 'Unlimited storage',
    description: 'Get access to out exclusive app that allows you to send unlimited transactions without getting charged fees.',
    buttonLabel: 'Start Now',
    imgStart: false,
    alt: 'car',
    img: './assets/img1.svg',
    dark: false,
    darkText: true,
    primary: false
}
export const homeObjFour = {
    id: 'update-profile',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Update Profile',
    headline: 'Unlimited storage',
    description: 'Get access to out exclusive app that allows you to send unlimited transactions without getting charged fees.',
    buttonLabel: 'Start Now',
    imgStart: false,
    alt: 'car',
    img: './assets/img1.svg',
    dark: false,
    darkText: true,
    primary: false
}